import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import validator from './utils/validator'
import './utils/filters'
import '@/stylus/icon/iconfont.css'
import toast from '@/common/toast/toast.js'
import axios from "axios"
import qs from "qs";
import md5 from 'js-md5'
Vue.prototype.$md5 = md5
import Pagination from "@/components/Pagination";
import clickoutside from 'element-ui/src/utils/clickoutside'
Vue.directive('clickoutside', clickoutside)

Vue.component('Pagination', Pagination)

import ElementUI from 'element-ui';
import { MessageBox, Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import "normalize.css/normalize.css";
import "flex.css";
import formCreate from '@form-create/element-ui';
import versionUpdate from './utils/versionUpdate';
import "./assets/style/global.css"; /*此页面用于修改并覆盖组件样式*/

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(validator)
Vue.use(toast)
Vue.use(ElementUI);
Vue.use(formCreate)

sync(store, router)

// 全部导入vant组件库
import vant from "vant"
import "vant/lib/index.css"

import echarts from 'echarts'
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    versionUpdate.isNewVersion();
    next()
})



function toEmotion(text, isNoGif) {
    var list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '愉快', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极', '嘿哈', '捂脸', '奸笑', '机智', '皱眉', '耶', '红包', '鸡'];
    // console.log('text,isNoGif',text,isNoGif)
    if (!text) {
        return text;
    }

    text = text.replace(/\[[\u4E00-\u9FA5]{1,3}\]/gi, function(word) {
        var newWord = word.replace(/\[|\]/gi, '');
        var index = list.indexOf(newWord);
        var backgroundPositionX = -index * 24
        var imgHTML = '';
        if (index < 0) {
            return word;
        }

        if (isNoGif) {
            if (index > 104) {
                return word;
            }
            imgHTML = `<i class="static-emotion" style="background:url(https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/default218877.gif) ${backgroundPositionX}px 0;"></i>`
        } else {
            var path = index > 104 ? '/img' : 'https://res.wx.qq.com/mpres/htmledition/images/icon';
            imgHTML = `<img class="static-emotion-gif" style="vertical-align: middle" src="${path}/emotion/${index}.gif">`
        }
        return imgHTML;
    });
    // console.log(text)
    return text;
}
Vue.directive('emotion', {
    bind: function(el, binding) {
        el.innerHTML = toEmotion(binding.value)
    }
});
Vue.filter('formatDate', function(value) {
    const date = new Date(value);
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1).toString().padStart(2, 0);
    let D = date.getDate().toString().padStart(2, 0);
    let H = date.getHours().toString().padStart(2, 0);
    let m = date.getMinutes().toString().padStart(2, 0);
    return `${Y}-${M}-${D} ${H}:${m}`;
})

import audio from 'vue-mobile-audio'
Vue.use(audio)
Vue.use(vant);
// 全部导入vant组件库
var axiosInstance = axios.create({
    // baseURL: '',  // api的base_url
    baseURL: 'https://api.weijub.com',
       // api的base_url 
    timeout: 180000,
       // 请求超时时间
})

let isAuth = true
axiosInstance.interceptors.response.use(
    response => {
        const res = response.data
            // if the custom code is not 20000, it is judged as an error.
            // if (res.code == 88 && res.msg == "请在风控管理-参数配置项完成密钥配置") {
            //   Message({
            //     message: res.msg,
            //     type: 'error',
            //     duration: 3 * 1000
            //   })
            //   router.push("/register/user/param")
            // }
        if (res.msg == "登录超时") {
            if (isAuth === false) {
                return response
            }
            isAuth = false
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 3 * 1000
            })
            console.log(router);
            router.push("/register");
            return response
        }
        if (res.msg == "登录成功！") {
            isAuth = true
        }
        return response
    },
    error => {
        // 用于调试
        console.log('error：' + error);
        // 状态码
        switch (error.response.status) {
            case 404:
            case 400:
                Message({ type: 'error', message: '客户端请求有语法错误，不能被服务器所理解' });
                break;
            case 403:
                Message({ type: 'error', message: '权限不足,请联系管理员!' });
                break;
            case 504:
            case 505:
            case 500:
                Message({ type: 'error', message: '服务器发生不可预期的错误' });
                break;
            default:
                Message({ type: 'error', message: '网络错误！' });
        }

        return Promise.reject(error);
    }
)

Vue.prototype.axios = axiosInstance;
Vue.prototype.qs = qs
Vue.prototype.$echarts = echarts;


// import VConsole from 'vconsole';
// new VConsole();

const wx = window.wx; // index.html中引入外部js，获取js暴露的wx
const WWOpenData = window.WWOpenData
Vue.$wx = Vue.prototype.$wx = wx;
Vue.$WWOpenData = Vue.prototype.$WWOpenData = WWOpenData;
import openData from "@/components/openData";
Vue.component('openData', openData)

const mixin = {
    data() {
        return {
            tooken: {}
        };
    },
    mounted() {
        if (window.localStorage.getItem("storuser")) {
            let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
            this.tooken = userinfo;
        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return "warning-row";
            }
            return "success-row";
        },
    }
}
Vue.mixin(mixin)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')